import { Button, Text } from '@nike/eds'
import { useGetWeightsAndMeasuresMissingQuery } from 'api/material'
import { UnitDetailsPanel } from 'components/left-detail-panel'
import { MainPanel } from 'components/main-panel'
import { Reprint } from 'components/reprint'
import { WarningBanner } from 'components/warning-banner'
import { useTranslation } from 'react-i18next'
import { type LabelType, type Unit } from 'types'
import { type ApiHandlerContext } from 'utils/useApiHandler'

interface ReworkProps {
  unitData: Unit
  handleReturn: () => void
  handleContinue: () => void
  printLabelContext: ApiHandlerContext<LabelType>
  weightsAndMeasuresRequired: boolean
}

export const Rework = ({ unitData, handleReturn, handleContinue, printLabelContext, weightsAndMeasuresRequired }: ReworkProps) => {
  const { t } = useTranslation()

  const { data: material } = useGetWeightsAndMeasuresMissingQuery(unitData.upc, { skip: !weightsAndMeasuresRequired })

  const leftPanelContent = <UnitDetailsPanel unit={unitData} showImage={true} />
  const rightPanelContent = <Reprint unit={unitData} printLabelContext={printLabelContext} />
  const mainPanelContent =
    <div className='flex flex-col flex-grow justify-between'>
      <Text font={'title-1'} as={'h1'} className={'my-6'}>{t('rework.title')}</Text>
        {material && !material.weightsAndMeasuresKnown && (
            <WarningBanner>
                {t('rework.warning_message_line_one')}
                <br/>
                <span className={'font-bold'}>{t('rework.warning_message_line_two')}</span>
            </WarningBanner>)
        }
      <div className="flex justify-between w-100 mt-20">
      <Button className='text-4xl' onClick={handleReturn} variant='secondary'>
          {t('buttons.return')}
      </Button>
      <Button
        className='text-4xl'
        onClick={handleContinue}
      >
        {t('buttons.continue')}
      </Button>
      </div>
    </div>

  return <MainPanel
    leftPanelContent={leftPanelContent}
    mainPanelContent={mainPanelContent}
    rightPanelContent={rightPanelContent}
  />
}
